export default "__VITE_ASSET__CtGIxxoI__"